/**
 * IAP product IDs registered in App Store Connect (iOS) and Play Console (Android).
 * These MUST match the IDs in the respective developer consoles exactly.
 */

export const IAP_PRODUCTS = {
  // ─── Subscriptions ───────────────────────────────────────────────────────
  MONTHLY_SUB:   'com.professya.app.sub.monthly',
  ANNUAL_SUB:    'com.professya.app.sub.annual',

  // ─── Question credits ─────────────────────────────────────────────────────
  QUESTIONS_Q3:  'com.professya.app.questions.q3',
  QUESTIONS_Q5:  'com.professya.app.questions.q5',
  QUESTIONS_Q10: 'com.professya.app.questions.q10',

  // ─── Synastry credits ─────────────────────────────────────────────────────
  SYNASTRY_S1:   'com.professya.app.synastry.s1',
  SYNASTRY_S3:   'com.professya.app.synastry.s3',

  // ─── AstroMatch credits ───────────────────────────────────────────────────
  ASTROMATCH_A3:  'com.professya.app.astromatch.a3',
  ASTROMATCH_A10: 'com.professya.app.astromatch.a10',
} as const;

export type IAPProductId = (typeof IAP_PRODUCTS)[keyof typeof IAP_PRODUCTS];

/** Map Professya product_prices.id → IAP_PRODUCTS identifier */
export const PRODUCT_TO_IAP: Record<string, IAPProductId> = {
  monthly_sub:    IAP_PRODUCTS.MONTHLY_SUB,
  annual_sub:     IAP_PRODUCTS.ANNUAL_SUB,
  questions_q3:   IAP_PRODUCTS.QUESTIONS_Q3,
  questions_q5:   IAP_PRODUCTS.QUESTIONS_Q5,
  questions_q10:  IAP_PRODUCTS.QUESTIONS_Q10,
  synastry_s1:    IAP_PRODUCTS.SYNASTRY_S1,
  synastry_s3:    IAP_PRODUCTS.SYNASTRY_S3,
  astromatch_a3:  IAP_PRODUCTS.ASTROMATCH_A3,
  astromatch_a10: IAP_PRODUCTS.ASTROMATCH_A10,
};
